export default __webpack_public_path__ + "static/media/ProductSans-Medium.66f4bb53.eot";